<template>
    <div class="ag-checkbox-header">
        <v-checkbox
            v-model="isChecked"
            aria-label="Select all"
            hide-details
            class="rtls-checkbox"
            dense
            :indeterminate="isIndeterminate"
            @change="onChange"
        />
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: ['params'],
    data() {
        return {
            isChecked: false,
            isIndeterminate: false,
        };
    },
    mounted() {
        this.updateCheckboxState();
        this.params.api.addEventListener('selectionChanged', this.updateCheckboxState);
    },
    beforeUnmount() {
        this.params.api.removeEventListener('selectionChanged', this.updateCheckboxState);
    },
    methods: {
        updateCheckboxState() {
            const selected = this.params.api.getSelectedRows().length;
            const total = this.params.api.getDisplayedRowCount();

            if (selected === 0) {
                this.isChecked = false;
                this.isIndeterminate = false;
            } else if (selected === total) {
                this.isChecked = true;
                this.isIndeterminate = false;
            } else {
                this.isChecked = false;
                this.isIndeterminate = true;
            }
            // For native indeterminate support
            if (this.$refs.checkbox) {
                this.$refs.checkbox.indeterminate = this.isIndeterminate;
            }
        },
        onChange(event) {
            const checked = event.target.checked;
            if (this.isIndeterminate) {
                this.params.api.deselectAll();
                this.emitter.emit('selectAllChanged', false);
                return;
            }
            if (checked) {
                this.params.api.selectAll();
            } else {
                this.params.api.deselectAll();
            }
            this.emitter.emit('selectAllChanged', checked);
        },
    },
});
</script>

<style scoped>
.ag-checkbox-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>
